const solutionList = [
    {
        imgPo: "imgLeft",
        type: "内窥镜模组",
        name: "微创内窥镜摄像机模组",
        title: "微创内窥镜摄像机模组",
        img: "/static/img/module/MicroCamera.png",
        point: ["定制化输出接口", "捆绑应用", "可高度定制化"],
        desc:
            "微创内窥镜摄像机模组，工业内窥镜摄像机模组，直径0.7mm到10mm，自定义测温、测距、多画面、自动对焦等功能，定制化输出接口，可以捆绑应用到需要可视医用的企业产品里面，适用领域：医疗：肺手术、泌尿手术；警用：信件、包裹、门缝和特别狭窄地方的安全检查；工业：铸件及零部件加工、微孔、盲孔、管道、军工领域 ",
        fc: [
            { img: "", name: "医疗" },
            { img: "", name: "警用" },
            { img: "", name: "工业" },
        ],
        btn: {
            show: true,
            text: "查看详情",
        },
        param: [
            { key: "外径", val: "730*730um(+/-40um)" },
            { key: "像素", val: "2.4 um x 2.4 um" },
            { key: "传感器", val: "AMS NanEyeXS" },
            { key: "线径", val: "小于1mm" },
            { key: "线长", val: "2m（0-2m" },
            { key: "帧率", val: "13-55fps" },
            { key: "视角", val: "120︒" },
            { key: "景深", val: "3-50mm" },
            { key: "扫描模式", val: "逐行扫描" },
            { key: "工作温度", val: "-30︒C  to  85︒C" },
            {
                key: "补光",
                val: "无/led*2（可定制光纤照明）",
            },
            { key: "视频接口", val: "HDMI/USB/TFT-LCD(可选)" },
        ],
    },
    {
        imgPo: "imgLeft",
        type: "USB3",
        name: "USB3.0 高像素高速率成像模块",
        title: "USB3.0 高像素高速率成像模块",
        img: "/static/img/module/USB3.0.png",
        point: ["定焦&变焦可选", "定制ISP"],
        desc:
            "USB3.0 高像素高速率成像模块，标准USB输出格式，可编逻辑器件主控，可根据不同产品应用领域定制化ISP，定焦&变焦可选，应用于教育、视频会议、工业检测等领域  ",
        fc: [
            { img: "", name: "教育" },
            { img: "", name: "视频会议" },
            { img: "", name: "工业检测" },
        ],
        btn: {
            show: true,
            text: "查看详情",
        },
        param: [
            { key: "传感器", val: "6.3mm*5.7mm" },
            { key: "镜头尺寸", val: "1/3.2" },
            { key: "像元尺寸", val: "1.1um*1.1um BSI" },
            { key: "最高有效像素", val: "4208H*3120V  1300万" },
            { key: "输出格式", val: "YUV，MJPEG" },
            {
                key: "视角",
                val:
                    "4096*3072(3.5fps),3840*2160(7.5fps),1920*1080(30fps)，1600*1200(30fps),1280*720(30fps),1024*768(30fps),800*600(30fps),640*480(30fps)",
            },
            { key: "信噪比", val: "37dB" },
            { key: "动态范围", val: "69dB" },
            { key: "接口类型", val: "USB3.0" },
            {
                key: "支持免去协议",
                val: "USB Video Class(UVC)",
            },
            { key: "3A控制", val: "支持" },
            { key: "供电方式", val: "USB BUS POWER" },
            { key: "工作电压：", val: "DV5V" },
            { key: "工作电流", val: "50mA〜200mA" },
            { key: "工作温度", val: "（0℃〜65℃）" },
            { key: "存储温度", val: "（-30℃〜85℃）" },
        ],
    },
    {
        imgPo: "imgLeft",
        type: "M300B",
        name: "USB嵌入式面部生物特征采集模组",
        title: "USB嵌入式面部生物特征采集模组",
        img: "/static/img/module/m300b.png",
        point: ["安全便捷", "双活体检测", "快速响应"],
        desc:
            "USB嵌入式面部身份信息采集模组，能够实现快速准确的面部多维生物特征信息的采集。采用实时反馈的辅助对焦技术，采集速度快、交互便捷；具有虹膜和人脸双重活体检测功能，实现超高安全性；提供专业化SDK开发套件，2天内实现集成开发和验证。            ",
        fc: [
            { img: "", name: "安防" },
            { img: "", name: "通关" },
            { img: "", name: "园区" },
        ],
        btn: {
            show: true,
            text: "查看详情",
        },
        param: [
            { key: "采集信息", val: "虹膜、可见光人脸、近红外人脸、深度信息" },
            { key: "识别距离", val: "虹膜：45~65cm/人脸：30~100cm" },
            { key: "注册时间", val: "人脸注册<1.5s；虹膜注册时间<2s；" },
            { key: "识别时间", val: "人脸识别 <0.8s；虹膜识别<1s" },
            { key: "识别误识率", val: "0.0001%" },
            { key: "识别拒识率", val: "0.1%" },
            { key: "虹膜近红外光源", val: "主动照明，照明符合IEC 62471:2006无伤害类标准" },
            { key: "近红外人脸红外光源", val: "主动照明，照明符合IEC 62471:2006无伤害类标准" },
            // { key: "活体检测", val: "1、支持静默活体检测" },
            // { key: "", val: "2、支持打印/显示屏/美瞳/脸膜等假体检测" },
            // { key: "", val: "3、人脸、虹膜可单独进行活体检测" },
            // {
            //     key: "选配组件",
            //     val: "可选配转动组件，使用转动组件的情况下，可适应>50cm的高度范围。",
            // },
            // { key: "使用环境", val: "室内环境/半室外(非阳光直射)" },
            // { key: "接口", val: "USB-3.0（兼容USB-2.0）；ZH1.5-2Y的电源接口" },
            { key: "工作温度", val: "-10℃~55℃" },
            { key: "工作湿度", val: "0%~90% RH，不结雾" },
            { key: "开发平台", val: "支持Android、Windows、Linux" },
            { key: "产品尺寸", val: "139*38*35mm(宽*高*厚)" },
            { key: "重量", val: "150g" },
            { key: "功率", val: "<7w" },
        ],
    },
    {
        classify: "module",
        imgPo: "imgLeft",
        type: "S300KQ",
        name: "S300KQ模组",
        title: "S300KQ模组",
        img: "/static/img/product/6.png",
        point: ["组网灵活", "扩展性强", "可高度定制化"],
        desc:
            "S300-KQ虹膜人脸识别一体模组，可高效安全完成虹膜人脸信息的注册和验证；镜头自动对焦，自动识别捕获用户虹膜，使用方便快捷；1：N精准识别方式，完备的数据库功能，全面支持数字后台管理和备份；创新应用的活体检测技术，拒绝任何仿冒造假行为。     ",
        fc: [
            { img: "", name: "便于二次开发" },
            { img: "", name: "扩展性强" },
        ],
        btn: {
            show: true,
            text: "查看详情",
        },
        param: [
            { key: "产品型号", val: "S300-KQ" },
            { key: "产品尺寸", val: "160mm*36mm*43mm" },
            { key: "虹膜识别距离", val: "45c~65cm" },
            { key: "识别身高范围", val: "支持根据用户身高自动调节" },
            { key: "注册时间", val: "<3s" },
            { key: "识别时间", val: "<1s" },
            { key: "识别误识率", val: "0.00001%" },
            { key: "识别拒识率", val: "0.1%" },
            { key: "虹膜图像", val: "符合ISO29794-6和ISO19794-6标准" },
            { key: "人脸图像", val: "符合ISO29794-5和ISO19794-5标准" },
            {
                key: "近红外光源",
                val: "LED光源符合IEC62471: 2006 无伤害类标准",
            },
            { key: "工作温度", val: "-10℃~55℃" },
            { key: "工作湿度", val: "0%-90% RH，不结露" },
        ],
    },
];

export default solutionList;
